document.addEventListener('DOMContentLoaded', function() {

  const MARKET_OPTIONS = [
    { label: 'Canada (CAD)',        countryCode: 'CA' },
    { label: 'United States (USD)', countryCode: 'US' },
    { label: 'International (USD)', countryCode: 'GB' }, // GB as representative international country
  ];

  function getCurrentMarketLabel(countryCode) {
    if (countryCode === 'CA') return 'Canada (CAD)';
    if (countryCode === 'US') return 'United States (USD)';
    return 'International (USD)';
  }

  function init() {
    const forms = document.querySelectorAll('form.localization--form, [data-type="localization"]');

    document.querySelectorAll('.disclosure--main').forEach(function(disclosureMain) {

      // Don't double-init
      if (disclosureMain.querySelector('.plaza-market-picker')) return;

      const toggle = disclosureMain.querySelector('.disclosure--toggle');
      const nativeList = disclosureMain.closest('[data-type="localization"]')
        ? disclosureMain.closest('[data-type="localization"]').querySelector('.disclosure--form')
        : null;

      if (!toggle) return;

      // Get current country code from the native current-option span
      const currentOptionWrapper = toggle.querySelector('.disclosure--current-option [data-country]');
      const rawCountry = currentOptionWrapper
        ? currentOptionWrapper.getAttribute('data-country')
        : (toggle.querySelector('.disclosure-option--wrapper') ? toggle.querySelector('.disclosure-option--wrapper').getAttribute('data-country') : 'CA');

      // Map country to market
      let currentCode = 'INTL';
      if (rawCountry === 'Canada') currentCode = 'CA';
      else if (rawCountry === 'United States') currentCode = 'US';

      // Update or create the label span
      let label = toggle.querySelector('.plaza-current-country');
      if (!label) {
        label = document.createElement('span');
        label.className = 'plaza-current-country';
        label.style.cssText = 'font-family: "Inter", sans-serif; font-size: 11px; letter-spacing: 0.1em; text-transform: uppercase; margin-right: 4px; font-weight: 400;';
        toggle.insertBefore(label, toggle.firstChild);
      }
      label.textContent = getCurrentMarketLabel(currentCode);

      // Hide flags
      disclosureMain.querySelectorAll('.icon--flag, img').forEach(el => el.style.display = 'none');

      // Build custom picker panel
      const picker = document.createElement('div');
      picker.className = 'plaza-market-picker';
      picker.style.cssText = `
        display: none;
        position: absolute;
        bottom: 100%;
        left: 0;
        background: var(--bg-color--body, #fff);
        border: 1px solid var(--border--color-dark, #e0e0e0);
        padding: 8px 0;
        min-width: 220px;
        z-index: 100;
        margin-bottom: 8px;
      `;

      MARKET_OPTIONS.forEach(function(option) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = option.label;
        btn.style.cssText = `
          display: block;
          width: 100%;
          text-align: left;
          padding: 10px 16px;
          font-family: "Inter", sans-serif;
          font-size: 11px;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          font-weight: ${option.countryCode === currentCode ? '600' : '400'};
          background: none;
          border: none;
          cursor: pointer;
          color: inherit;
          opacity: ${option.countryCode === currentCode ? '1' : '0.6'};
        `;

        btn.addEventListener('click', function() {
          // Find and click the matching native li
          const root = disclosureMain.closest('[data-type="localization"]') || document;
          const nativeLi = root.querySelector('.disclosure--option[data-value="' + option.countryCode + '"]');
          if (nativeLi) {
            nativeLi.click();
          }
          picker.style.display = 'none';
        });

        picker.appendChild(btn);
      });

      // Position relative needed on parent
      disclosureMain.style.position = 'relative';
      disclosureMain.appendChild(picker);

      // Toggle picker on button click (intercept before native handler)
      toggle.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        picker.style.display = picker.style.display === 'none' ? 'block' : 'none';
      });

      // Close on outside click
      document.addEventListener('click', function(e) {
        if (!disclosureMain.contains(e.target)) {
          picker.style.display = 'none';
        }
      });
    });
  }

  init();
  document.addEventListener('shopify:section:load', init);
});
